import 'whatwg-fetch';
export var json = function (url) {
    var fetch = window.fetch;
    return new Promise(function (resolve) {
        fetch(url, { headers: { 'x-client-app': 'skland' } })
            .then(function (response) {
            return response.json();
        })
            .then(function (data) {
            resolve({ code: 0, data: data, message: '' });
        })
            .catch(function (error) {
            resolve({ code: -1, data: null, message: error.message });
        });
    });
};
